import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Badge,
} from "@chakra-ui/react";
import axios from "axios";
// Definir la interfaz para los turnos
interface Turno {
  ID: number;
  Folio: string;
  Area: string;
  FechaCreacion: string;
  Estado: string;
  UsuarioAsignado: string | null;
  Notas: string | null;
  FechaAtencion: string | null;
  CajaID: number | null;
}



const TurnosRealTime = () => {
  const [turnosPendientes, setTurnosPendientes] = useState<Turno[]>([]);

//  const [turnosPendientes, setTurnosPendientes] = useState<string[]>([]);
  const [turnosAtendidos, setTurnosAtendidos] = useState<{ [key: string]: string }>({});
  const [cajas, setCajas] = useState<{ ID: number; NumeroCaja: number; Estado: string; PrefijosPermitidos: string }[]>([]);
  const [loading, setLoading] = useState(false);

  // Obtener turnos y cajas desde la API
  const fetchData = async () => {
    //setLoading(true);
    try {
      const [turnosResponse, cajasResponse] = await Promise.all([
        axios.get("http://52.91.130.91:5000/api/turnos"),
        axios.get("http://52.91.130.91:5000/api/cajas"),
      ]);
  
      // Procesar turnos
      if (turnosResponse.data) {
        const { proximosTurnos, turnosEnAtencion } = turnosResponse.data;
  
        // ⚠️ Corrección: Guardar los objetos completos en lugar de solo `Folio`
        setTurnosPendientes(proximosTurnos);
  
        // Crear un objeto con los turnos en atención { CajaID: Folio }
        const atendidos: { [key: string]: string } = {};
        turnosEnAtencion.forEach((turno: any) => {
          atendidos[`Caja ${turno.CajaID}`] = turno.Folio;
        });
  
        setTurnosAtendidos(atendidos);
      }
  
      // Procesar cajas
      if (cajasResponse.data) {
        setCajas(cajasResponse.data);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };
  

  // Enviar turno al API asignando a una caja específica
  const asignarTurnoACaja = async (cajaID: number) => {
    try {
      const response = await axios.post("http://52.91.130.91:5000/api/turnos/asignar", {
        cajaID, // Enviar el número de caja
      });

      if (response.data.message) {
        alert(response.data.message);
      } else {
        fetchData(); // Actualizar lista de turnos y cajas después de asignar
      }
    } catch (error) {
      console.error("Error al asignar el turno:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box p={6} bg="gray.50" borderRadius="md" boxShadow="md" maxW="800px" mx="auto" textAlign="center">
      <Text fontSize="2xl" fontWeight="bold" color="teal.500">
        Turnos en Tiempo Real
      </Text>

      {loading ? (
        <Spinner size="xl" mt={4} />
      ) : (
        <VStack spacing={4} mt={4}>
          <Box p={4} bg="white" borderRadius="md" boxShadow="md" width="100%">
            <Text fontSize="lg" fontWeight="bold">Turnos en Atención</Text>
            <Table variant="simple" size="sm" mt={2}>
              <Thead>
                <Tr>
                  <Th>Caja</Th>
                  <Th>Turno</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.keys(turnosAtendidos).length > 0 ? (
                  Object.entries(turnosAtendidos).map(([caja, folio]) => (
                    <Tr key={caja}>
                      <Td>{caja}</Td>
                      <Td>{folio}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={2} textAlign="center">No hay turnos en atención.</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>

          <Box p={4} bg="white" borderRadius="md" boxShadow="md" width="100%">
          <Box p={4} bg="white" borderRadius="md" boxShadow="md" width="100%">
  <Text fontSize="lg" fontWeight="bold">Próximos Turnos ({turnosPendientes.length})</Text>
  <Table variant="simple" size="sm" mt={2}>
    <Thead>
      <Tr>
        <Th>#</Th>
        <Th>Turno</Th>
        {/* <Th>Área</Th> */}
        <Th>Fecha Creación</Th>
      </Tr>
    </Thead>
    <Tbody>
      {turnosPendientes.length > 0 ? (
        turnosPendientes.map((turno, index) => (
          <Tr key={turno.ID}>
            <Td>{index + 1}</Td>
            <Td>
              <Badge colorScheme="blue" px={2} py={1} borderRadius="md">
                {turno.Folio}
              </Badge>
            </Td>
            {/* <Td>{turno.CajaID}</Td> */}
            {/* <Td>{turno.Area}</Td> */}
            <Td>{new Date(turno.FechaCreacion).toLocaleString()}</Td>
          </Tr>
        ))
      ) : (
        <Tr>
          <Td colSpan={4} textAlign="center">No hay turnos pendientes.</Td>
        </Tr>
      )}
    </Tbody>
  </Table>
</Box>
<HStack spacing={4} justifyContent="center" mt={2}>
  {cajas.map((caja) => (
    <Box 
      key={caja.ID} 
      textAlign="center"
      borderWidth="2px" // Borde visible
      borderColor="black" // Color del borde
      borderRadius="md" // Bordes redondeados (ajústalo según prefieras)
      p={4} // Padding interno para que el borde no toque el contenido
    >
      <Button
        colorScheme={caja.Estado === "Disponible" ? "green" : "red"}
        onClick={() => asignarTurnoACaja(caja.ID)}
      >
        Caja {caja.NumeroCaja}
      </Button>
      <Box mt={2}>
        {caja.PrefijosPermitidos.split(",").map((prefijo) => (
          <Badge key={prefijo} colorScheme="green" mx={1}>
            {prefijo}
          </Badge>
        ))}
      </Box>
    </Box>
  ))}
</HStack>


          </Box>
        </VStack>
      )}
    </Box>
  );
};

export default TurnosRealTime;
